import { render, staticRenderFns } from "./SurveysPage.vue?vue&type=template&id=5aa85e0e&"
import script from "./SurveysPage.vue?vue&type=script&lang=js&"
export * from "./SurveysPage.vue?vue&type=script&lang=js&"
import style0 from "./SurveysPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports